import { Spacer, StatusTag } from '@sparemin/blockhead';
import styled from 'styled-components';
import { SpeakerLabelFormattingStyleProps } from './types';

export const Contents = styled(Spacer).attrs({
  space: '24px',
  orientation: 'vertical',
  align: 'flex-start',
  justify: 'center',
})`
  width: 100%;
`;

export const FormatContainer = styled(
  Spacer,
).attrs<SpeakerLabelFormattingStyleProps>({
  space: '8px',
  orientation: 'vertical',
  align: 'flex-start',
  justify: 'center',
})`
  width: 100%;

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    opacity: 0.25;
    pointer-events: none;
  `}
`;

export const Tag = styled(StatusTag).attrs({
  color: 'secondary',
})`
  margin-left: 8px;
  font-size: 10px;
  font-weight: 700;
`;

export const FrequencyImage = styled.img`
  width: 127px;
  height: 125px;

  & + & {
    margin-left: 6px;
  }
`;
